import React, { Component } from "react";
import Select from "react-select";
import axios from "axios";
import { api } from "../utils/Api";

export default class PsiPickerID extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedOption: "",
			isClearable: true,
			isSearchable: true,
			psi: [],
		};
	}

	getPsi = async () => {
		const url = api + "/psi/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			this.setState({
				psi: data,
			});
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	componentDidMount() {
		this.getPsi();
	}

	render() {
		const options = this.state.psi.map((pressure) => {
			return {
				value: pressure._id,
				label: pressure.psi,
			};
		});

		return (
			<div>
				<Select
					name="form-field-name"
					placeholder="psi..."
					value={options.filter((option) => {
						return option.value === this.props.selectedOption;
					})}
					onChange={this.props.action}
					isClearable={this.state.isClearable}
					isSearchable={this.state.isSearchable}
					options={options}
					isDisabled={this.props.isDisabled ? true : false}
				/>
			</div>
		);
	}
}
